<template>
  <v-card v-ripple :disabled="chat.disabeld">
    <v-container grid-list-lg fluid>
      <v-layout row wrap>
        <v-flex xs3>
          <v-avatar :style="{ 'background-color': channels.find(item => item.value === chat.channel_id).color }">
            <v-icon class="white--text">{{ channels.find(item => item.value === chat.channel_id).icon }}</v-icon>
          </v-avatar>
        </v-flex>
        <v-flex xs9>
          <p class="text-truncate">
            <v-tooltip bottom>
              <span slot="activator">
                {{ chat | getName }}
              </span>
              <span>
                {{ chat | getName }}
              </span>
            </v-tooltip>
          </p>
          <small class="text-truncate">
            <v-tooltip bottom>
              <span slot="activator">
                {{ chat.internal_id }}
              </span>
              <span>
                {{ chat.internal_id }}
              </span>
            </v-tooltip>
          </small>
        </v-flex>
      </v-layout>
      <v-layout row wrap style="min-height: 37px;">
        <v-flex xs12>
          <div class="text-truncate">
            <v-tooltip bottom>
              <span slot="activator">
                {{ formatLastMessage(chat.chat_center_messages) }}
              </span>
              <span>
                {{ formatLastMessage(chat.chat_center_messages) }}
              </span>
            </v-tooltip>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="chat-info" justify-space-between>
        <v-flex shrink>
          <v-tooltip top>
            <v-icon slot="activator">fa-clock</v-icon>
            Tiempo de espera: {{ chat.last_activity | timeWaiting }}
          </v-tooltip>
        </v-flex>
        <v-flex shrink>
          <v-tooltip top>
            <v-icon slot="activator">fa-user</v-icon>
            <span>
              Asignado a:
              <template v-if="chat.user">
                {{ chat.user.first_name }} {{ chat.user.last_name }}
              </template>
              <template v-else>
                Sin asignar
              </template>
            </span>
          </v-tooltip>
        </v-flex>
        <v-flex shrink>
          <v-tooltip top>
            <v-icon slot="activator">fa-info-circle</v-icon>
            Estado: {{ getStatusByField(chat.chat_center_status_id, 'id', 'status') }}
          </v-tooltip>
        </v-flex>
        <v-flex shrink>
          <v-tooltip top>
            <v-icon slot="activator" :class="{
              'k-orange-linear-text': chat.intention_id,
            }">fa-lightbulb</v-icon>
            Intención: {{ chat.intention_id ? intention(chat.intention_id).name : 'Sin intención' }}
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import moment from 'moment';
import chatCenterMixin from '@/mixins/chatCenterMixin';
import removeImgTags from '@/mixins/removeImgTags';
import removeHtmlTags from '@/mixins/removeHtmlTags';

export default {
  props: {
    channels: {
      type: Array,
      default: () => [],
    },
    chat: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [
    chatCenterMixin,
    removeImgTags,
    removeHtmlTags,
  ],
  computed: {
    ...mapGetters([
      'intention',
    ]),
  },
  filters: {
    timeWaiting(time) {
      return moment.utc(time).local().locale('es').fromNow(true);
    },
  },
  methods: {
    formatLastMessage(messages) {
      if (messages && messages.length) {
        const filteredMessages = _.orderBy(messages, ['created_at', 'id'], ['asc', 'asc']);
        const lastMessage = filteredMessages[filteredMessages.length - 1];
        if (Object.keys(lastMessage || {}).length && lastMessage.text) {
          let lastMessageFormatted = '';
          if (lastMessage.origin) {
            lastMessageFormatted = 'Tu: ';
          }
          if (lastMessage.type === 'media') {
            const text = JSON.parse(lastMessage.text || '{}');
            lastMessageFormatted += text ? (text.caption ? text.caption : 'Archivo') : '';
          } else if ((lastMessage.text || '').includes('<span class="image-caption">')) {
            lastMessageFormatted += this.removeHtmlTags(lastMessage.text);
          } else if ((lastMessage.text || '').includes('<audio controls')) {
            lastMessageFormatted += 'Audio';
          } else if (['image', 'audio', 'document', 'ptt'].includes(lastMessage.type)) {      
            switch (lastMessage.type) {
              case 'image':
                lastMessageFormatted += 'Imagen';
                break;
              case 'audio':
              case 'ptt':
                lastMessageFormatted += 'Audio';
                break;
              case 'document':
                lastMessageFormatted += lastMessage.text.split('/').pop().split('.').pop();
                break;
            }
          } else {
            lastMessageFormatted += this.removeHtmlTags(this.removeImgTags(lastMessage.text));
          }
          return lastMessageFormatted;
        }
      }

      return '';
    },
  },
};
</script>
<style scoped>
  .card {
    cursor: pointer;
  }
  .chat-info .fa {
    font-size: 20px !important;
  }
  .text-truncate {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/ChatCard.vue